module.exports = __webpack_public_path__ + "img/madera015.1984d0dc.jpg";